import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchEmployees = ({ accountId, ...params }) => get(`/accounts/${accountId}/employees`, params);

export const addEmployee = ({ accountId, ...params }) => post(`/accounts/${accountId}/employees`, params);

export const fetchEmployee = ({ accountId, employeeId }) => get(`/accounts/${accountId}/employees/${employeeId}`);

export const updateEmployee = ({ accountId, employeeId, ...params }) =>
  patch(`/accounts/${accountId}/employees/${employeeId}`, params);

export const resendAdminEmail = ({ accountId, employeeId }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/admins/invite`);

export const fetchEmployeeApplications = ({ accountId, employeeId, includeRejectedApplications }) =>
  get(`/accounts/${accountId}/employees/${employeeId}/applications`, { includeRejectedApplications });

export const fetchEmployeeComments = ({ accountId, employeeId }) =>
  get(`/accounts/${accountId}/employees/${employeeId}/comments`);

export const addEmployeeComment = ({ accountId, employeeId, comment, typeId }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/comments`, { comment, typeId });

export const fetchEmployeeCompliance = ({ accountId, employeeId }) =>
  get(`/accounts/${accountId}/employees/${employeeId}/compliance`);

export const inviteEmployee = ({ accountId, employeeId }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/invite`);

export const fetchEmployeePackages = ({ accountId, employeeId }) =>
  get(`/accounts/${accountId}/employees/${employeeId}/packages`);

export const updateEmployeePhoto = ({ accountId, employeeId, employeePhotoId, isSharedWithClient }) =>
  patch(`/accounts/${accountId}/employees/${employeeId}/photos/${employeePhotoId}`, { isSharedWithClient });

export const fetchEmployeeJobStats = ({
  accountId,
  employeeId,
  futureFromDate,
  futureToDate,
  pastFromDate,
  pastToDate,
  includeRejectedApplications = true
}) =>
  get(`/accounts/${accountId}/employees/${employeeId}/stats/jobs`, {
    futureFromDate,
    futureToDate,
    pastFromDate,
    pastToDate,
    includeRejectedApplications
  });

export const fetchEmployeeShiftUnbookings = ({ accountId, employeeId }) =>
  get(`/accounts/${accountId}/employees/${employeeId}/unbookings`);

export const updateBulkEmployees = ({ accountId, employees }) =>
  post(`/accounts/${accountId}/employees/batch`, { employees });

export const updateEmployeesBulkParams = ({ accountId, employeeIds, updateParams }) =>
  post(`/accounts/${accountId}/employees/bulk-edit`, { employeeIds, updateParams });

export const exportEmployees = ({ toSendMail, accountId, ...params }) =>
  get(`/accounts/${accountId}/employees/dump`, { toSendMail, ...params });

export const fetchOSEmployee = ({ accountId, employeeId, contextProjectId, contextShiftId }) =>
  get(`/accounts/${accountId}/employees/os/${employeeId}`, { contextProjectId, contextShiftId });

export const updateOSEmployee = ({ accountId, employeeId, ...params }) =>
  patch(`/accounts/${accountId}/employees/os/${employeeId}`, params);

export const fetchEmployeesStats = ({ accountId, filters, searchTerm, branches }) =>
  get(`/accounts/${accountId}/employees/stats`, { filters, searchTerm, branches });

export const deleteEmployee = ({ accountId, employeeId }) =>
  httpDelete(`/accounts/${accountId}/employees/${employeeId}`);

export const permanentlyDeleteEmployee = ({ accountId, employeeId }) =>
  httpDelete(`/accounts/${accountId}/employees/${employeeId}/permanent`);

export const deleteEmployeeComment = ({ accountId, employeeId, id }) =>
  httpDelete(`/accounts/${accountId}/employees/${employeeId}/comments/${id}`);

export const createBulkEmployeesJobs = ({ accountId, jobEntries }) =>
  post(`/accounts/${accountId}/employees/jobs-batch`, { jobEntries });
